import React, { Component } from 'react';

class NavMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      buttonText: 'menu',
      menuActiveClass: ''
    }
    this.toggleMenu = this.toggleMenu.bind(this);
  }

  toggleMenu() {
    this.toggleButtonText();
    this.toggleClassName();
  }

  toggleButtonText(e) {
    const buttonText = this.state.buttonText === 'menu' ? 'x' : 'menu';
    this.setState({buttonText});
  }

  toggleClassName(e) {
    const menuClass = this.state.menuActiveClass === '' ? 'active' : '';
    this.setState({menuActiveClass: menuClass});
  }

  render() {

    return(
      <div className={`nav-menu ${this.state.menuActiveClass}`}>
        <span className="button" onClick={this.toggleMenu}>
          {this.state.buttonText}
        </span>

        <ul>
          <li><a href="/">home</a></li>
          <li><a href="https://cash.me/$JasonFarmer">Send Payment</a></li>
        </ul>
      </div>
    )
  }
}

export default NavMenu;